import { render, staticRenderFns } from "./AbstractType.vue?vue&type=template&id=ef693bb8&scoped=true"
import script from "./AbstractType.vue?vue&type=script&lang=js"
export * from "./AbstractType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef693bb8",
  null
  
)

export default component.exports